"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _444bfIcon = createIcon({
  displayName: "_444bfIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path d="m72.955 160.303h74.748v74.747h-74.748z" fill="currentColor" />
      <path d="m73.328 264.949h74.748v74.747h-74.748z" fill="currentColor" />
      <path d="m73.516 369.595h74.747v74.748h-74.747z" fill="currentColor" />
      <path d="m72.861 55.657h74.747v74.748h-74.747z" fill="currentColor" />
      <path
        d="m414.75 249.918c4.929-76.658 73.935-190.163-58.733-190.163-111.138 0-118.596 96.192-118.596 190.163 0 84.969 4.044 186.586 106.526 190.163 142.872 4.986 76.281-104.975 70.803-190.163z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _444bfIcon;
